(() => {
  const init = (root = document) => {
    root.querySelectorAll('.aq-navigation').forEach((nav) => {
      if (nav.dataset.ready) return;
      nav.dataset.ready = 'true';
      const menus = [...nav.querySelectorAll('details')];
      const close = (menu, focus = false) => {
        menu.open = false;
        menu.querySelector('summary').setAttribute('aria-expanded', 'false');
        if (focus) menu.querySelector('summary').focus();
      };
      menus.forEach((menu) => {
        const summary = menu.querySelector('summary');
        summary.setAttribute('aria-expanded', 'false');
        menu.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(menu.open));
          if (menu.open) menus.filter((other) => other !== menu).forEach((other) => close(other));
          const header = nav.closest('sticky-header');
          if (header) header.preventHide = menus.some((item) => item.open);
        });
        menu.querySelector('button').addEventListener('click', () => close(menu, true));
      });
      nav.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') menus.filter((menu) => menu.open).forEach((menu) => close(menu, true));
      });
      document.addEventListener('click', (event) => {
        if (!nav.contains(event.target)) menus.forEach((menu) => close(menu));
      });
      nav.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!nav.contains(document.activeElement)) menus.forEach((menu) => close(menu));
        });
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
